<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.628 1.202A1 1 0 0 0 9.425 1.2L1.4 7.22a1 1 0 0 0 .6 1.8h1.006V17a1 1 0 0 0 1 1h12.038a1 1 0 0 0 1-1V9.02H18a1 1 0 0 0 .602-1.798l-7.974-6.02ZM5.006 8.02a.998.998 0 0 0-.339-.75l5.356-4.018 5.343 4.033a.997.997 0 0 0-.322.735V16H13v-3a3 3 0 0 0-6 0v3H5.006V8.02ZM9 16h2v-3a1 1 0 0 0-2 0v3Z" />
    </svg>
</template>
